// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shimmer skeleton — consumers opt in independently from the token contract. */
.animate-shimmer {
  background: linear-gradient(
    90deg,
    hsl(var(--muted)) 25%,
    hsl(var(--muted-foreground) / 0.06) 50%,
    hsl(var(--muted)) 75%
  );
  background-size: 200% 100%;
  animation: shimmer var(--component-shimmer-duration) ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Flow links: dashes march along each link in its direction. */
.specra-flow-march {
  stroke-dasharray: 6 4;
  animation: specra-flow-march var(--component-flow-march-duration) linear infinite;
}

@keyframes specra-flow-march {
  to {
    stroke-dashoffset: -10;
  }
}

@media (prefers-reduced-motion: reduce) {
  .specra-flow-march {
    animation: none;
  }

  .animate-shimmer {
    animation-duration: var(--component-shimmer-reduced-duration);
  }

  .specra-spinner {
    animation-duration: var(--component-spinner-reduced-duration);
  }
}

/* Chat visuals arrive with a short rise, not a pop. */
@keyframes specra-visual-enter {
  from {
    opacity: 0;
    transform: translateY(var(--space-1));
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.specra-visual-enter {
  animation: specra-visual-enter var(--dur-slow) ease-out both;
}
@media (prefers-reduced-motion: reduce) {
  .specra-visual-enter {
    animation: none;
  }
}

/* Bars grow from their baseline when a chart arrives; a changed value slides. */
@keyframes specra-bar-grow {
  from {
    transform: scaleX(0);
  }
  to {
    transform: none;
  }
}
.specra-bar-grow {
  transform-origin: left center;
  animation: specra-bar-grow var(--component-visual-reveal-duration) cubic-bezier(0.2, 0.7, 0.2, 1)
    both;
  transition: width var(--dur-slow) ease-out;
}

/* A line chart draws left to right. */
@keyframes specra-line-draw {
  from {
    clip-path: inset(0 100% 0 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
}
.specra-line-draw {
  animation: specra-line-draw var(--component-visual-reveal-duration) ease-out both;
}

@media (prefers-reduced-motion: reduce) {
  .specra-bar-grow,
  .specra-line-draw {
    animation: none;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-components/src/styles/specra-behaviors.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,yEAAyE;AAC3E;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,+DAA+D;AAC/D;EACE,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,4DAA4D;AAC9D;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,6BAA6B;EAC7B;QACM;EACN,0CAA0C;AAC5C;;AAEA,sCAAsC;AACtC;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iFAAiF;AACnF;;AAEA;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Shimmer skeleton — consumers opt in independently from the token contract. */\n.animate-shimmer {\n  background: linear-gradient(\n    90deg,\n    hsl(var(--muted)) 25%,\n    hsl(var(--muted-foreground) / 0.06) 50%,\n    hsl(var(--muted)) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer var(--component-shimmer-duration) ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Flow links: dashes march along each link in its direction. */\n.specra-flow-march {\n  stroke-dasharray: 6 4;\n  animation: specra-flow-march var(--component-flow-march-duration) linear infinite;\n}\n\n@keyframes specra-flow-march {\n  to {\n    stroke-dashoffset: -10;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .specra-flow-march {\n    animation: none;\n  }\n\n  .animate-shimmer {\n    animation-duration: var(--component-shimmer-reduced-duration);\n  }\n\n  .specra-spinner {\n    animation-duration: var(--component-spinner-reduced-duration);\n  }\n}\n\n/* Chat visuals arrive with a short rise, not a pop. */\n@keyframes specra-visual-enter {\n  from {\n    opacity: 0;\n    transform: translateY(var(--space-1));\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.specra-visual-enter {\n  animation: specra-visual-enter var(--dur-slow) ease-out both;\n}\n@media (prefers-reduced-motion: reduce) {\n  .specra-visual-enter {\n    animation: none;\n  }\n}\n\n/* Bars grow from their baseline when a chart arrives; a changed value slides. */\n@keyframes specra-bar-grow {\n  from {\n    transform: scaleX(0);\n  }\n  to {\n    transform: none;\n  }\n}\n.specra-bar-grow {\n  transform-origin: left center;\n  animation: specra-bar-grow var(--component-visual-reveal-duration) cubic-bezier(0.2, 0.7, 0.2, 1)\n    both;\n  transition: width var(--dur-slow) ease-out;\n}\n\n/* A line chart draws left to right. */\n@keyframes specra-line-draw {\n  from {\n    clip-path: inset(0 100% 0 0);\n  }\n  to {\n    clip-path: inset(0 0 0 0);\n  }\n}\n.specra-line-draw {\n  animation: specra-line-draw var(--component-visual-reveal-duration) ease-out both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .specra-bar-grow,\n  .specra-line-draw {\n    animation: none;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
